import { Button } from '@/components/ui/elements/button';
import { Input } from '@/components/ui/elements/input';
import { Heading3 } from '@/components/ui/typography/Typography';
import { ModelID } from '@/types';
import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

export const EventLookup = () => {
  const navigate = useNavigate();
  const [id, setID] = useState<ModelID>();

  const goToEvent = () => {
    if (!id) return;
    navigate({ to: `/events/event/${id}/overview` });
  };

  return (
    <div className="rounded border px-4 pt-2 pb-4 bg-background">
      <Heading3>Go To Event</Heading3>
      <div className="flex space-x-1">
        <Input
          type="number"
          name="event_id"
          placeholder="Event ID..."
          defaultValue={id}
          onChange={(event) => setID(event.target.value)}
        />
        <Button onClick={goToEvent} size="lg" disabled={!id} id="load-event-submit">
          Go
        </Button>
      </div>
    </div>
  );
};
